import React from 'react';

import type { Media as MediaType } from '../../../payload/payload-types';
import { ProductHeroProps } from '@/app/_blocks/ProductHeroGraphQL/types';
import { Button } from '../Button';
import { Media } from '../Media';

import classes from './ProductHero.module.scss';

export const ProductHero: React.FC<{
  className?: string;
  productHero: ProductHeroProps;
}> = ({ className, productHero }) => {
  return (
    <div className={['grid', className, classes.wrapper].filter(Boolean).join(' ')}>
      Empty
    </div>
  );
};

export default ProductHero;
